"use strict";

var $ = require("jquery");
import { dropdownHeight } from './_dropdownHeight.js';

$(document).ready(function () {

    const navCategoriesDropdownInner = $('.nav-categories-dropdown .inner');
    const miniCartDropdownInner = $('.mini-cart-dropdown .inner');
    const productFilters = $('.product-filters');
    const searchFormDropdownInner = $('.search-form-dropdown .inner');

    dropdownHeight(navCategoriesDropdownInner, 1200);
    dropdownHeight(miniCartDropdownInner);
    dropdownHeight(productFilters);
    dropdownHeight(searchFormDropdownInner);

    window.addEventListener('resize', () => {

        dropdownHeight(navCategoriesDropdownInner, 1200);
        dropdownHeight(miniCartDropdownInner);
        dropdownHeight(productFilters);
        dropdownHeight(searchFormDropdownInner);
    });
});